import { FtpSettings } from '../models/ftpSettings'

export interface FtpSettingsStateType {
  ftpSettings: FtpSettings[]
  ftpSetting: FtpSettings | null
}

const FtpSettingsState: () => FtpSettingsStateType = () => ({
  ftpSettings: [],
  ftpSetting: null,
})

export default FtpSettingsState
